// src/api/dlpApi.js
// Frontend client for the DLP (Data Loss Prevention) API.
// Backend lives at /api/dlp/* — never call Anthropic directly from the browser.
import apiClient from "./apiClient";

// Fetch the user's DLP config: mode + custom rules
export async function getDlpRules() {
  const response = await apiClient.get("/api/dlp/rules");
  return response.data; // { mode, rules: [...] }
}

// Save the user's DLP config
export async function saveDlpRules({ mode, rules }) {
  const response = await apiClient.put("/api/dlp/rules", { mode, rules });
  return response.data; // { saved: true, mode, rules }
}

// Test-scrub a sample text — returns the scrubbed version + stats
export async function previewDlp(text) {
  const response = await apiClient.post("/api/dlp/preview", { text });
  return response.data; // { scrubbed, stats: { mode, totalRedactions, uniqueTokens, byLabel }, mode }
}
